import { ActionReducerMap } from "@ngrx/store";
import { StepBarState, stepBarReducer } from './stepbar.reducer';
import { LOBDataState, lobDataReducer } from "./lobData.reducer";

interface AppState {
    stepBarState: StepBarState | undefined;
    lobDataState: LOBDataState | undefined
}

export const reducers: ActionReducerMap<AppState> = {
    stepBarState: stepBarReducer,
    lobDataState: lobDataReducer
};

export const getAllState = (state: any) => state;
